<template>
  <div>
    <div class="container px-3 py-2" style="min-height: 100%">
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)">
            <div class="row">
              <div
              :class="columns.length <= 6 ? 'col-12' : 'col-6'"
              >
                <div
                v-for="item in columnFirst"
                :key="item.name"
              >
                <ValidateForm
                  :storageList="app.storageAll"
                  :disableStorage="true"
                  :disable="!checkPermissionFieldEdit(item.name)"
                  :item="item"
                  v-model="formData[item.name]"
                  :contactEmployees="contact.swEmployees"
                  :lockUnmanagedEmployees="true"
                />
              </div>
              </div>

              <div class="col-6" style="max-height: 390px; overflow-y: scroll">
                <div class="pe-2" v-for="item in columnSecond" :key="item.name">
                  <ValidateForm
                    :storageList="app.storageAll"
                    :disableStorage="true"
                    :disable="!checkPermissionFieldEdit(item.name)"
                    :item="item"
                    v-model="formData[item.name]"
                    :contactEmployees="contact.swEmployees"
                    :lockUnmanagedEmployees="true"
                  />
                </div>
              </div>
          </div>
          <span
              slot="footer"
              class="dialog-footer py-2 d-flex justify-content-end"
            >
              <el-button size="medium" @click="close">Huỷ</el-button>
              <el-button
                size="medium"
                type="primary"
                @click="submitFormWithValidation"
              >
                Hoàn thành
              </el-button>
            </span>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import ValidateForm from "@/components/common/ValidateForm.vue";
import { HTTP } from "@/lib/http-common";

export default {
  props: ["currentWorkflow", "contact", "steps", "updateWorkflow", "newWorkflow","processId"],
  components: {
    ValidateForm,
  },
  created() {
    this.fetchAndConvertColumns();
  },
  data() {
    return {
      formData: {},
      columns: [],
      columnFirst: [],
      columnSecond: [],
    };
  },

  methods: {
    parseJsonSafe(value, defaultValue = []) {
      if (!value || typeof value !== 'string' || !value.trim()) {
        return defaultValue;
      }

      try {
        return JSON.parse(value);
      } catch (e) {
        console.error('JSON parse error:', value, e);
        return defaultValue;
      }
    },
    checkContentHeight() {
      if (this.columns.length > 2) {
        this.$emit("expand-dialog", true);
      } else {
        this.$emit("expand-dialog", false);
      }
    },
    convertDataColumns() {
      this.columns.forEach((col) => {
        if (!["displayName", "phone", "email", "employees", "storage"].includes(col.name)) {
          if (this.formData[col.name] !== undefined) return; 

          if (col.columnType === "MultiSelect" || col.columnType === "Array" || col.columnType === "ArrayNumber") {
             this.$set(this.formData, col.name, col.defaultValue != "" ? JSON.parse(col.defaultValue) : []);
          } else if (col.columnType === "Number") {
            const numValue = !isNaN(Number(col.defaultValue)) ? Number(col.defaultValue) : null;
            this.$set(this.formData, col.name, numValue);
          } else {
            this.$set(this.formData, col.name, col.defaultValue ?? "");
          }
        }
      });
    },
    async fetchColumnsByDisplayColumn() {
      const processId =  this.app.globalProcessId === 'all' ? 0 : this.app.globalProcessId;
      const res = await HTTP.get("/api/column/get-all?processId=" + processId);

      const fieldNames = this.newWorkflow.columnList;
      const existingFields = this.getFieldsName;

      // employees lấy thẳng từ contact: tra theo title như các cột khác sẽ trượt
      // khi cột được đổi tên, mà trượt thì select nhân viên khởi tạo rỗng và
      // lần lưu kế tiếp sẽ gỡ sạch nhân viên cũ của contact.
      this.$set(
        this.formData,
        "employees",
        (this.contact.swEmployees || []).map((e) => e.id)
      );

      this.columns = res.data
        .filter((column) => {
          const hasPermission = this.checkPermissionFieldRead(column.name);
          return hasPermission;
        })
        .filter((col) => fieldNames?.includes(col.name))
        .filter((col) => col.name !== "note")
        .map((col) => {
          if (col.name !== "employees") {
            const existingValue = existingFields.find((field) => field.title === col.title);
            this.formData[col.name] = existingValue ? existingValue.value : "";
          }

          return col;
        });

      this.checkContentHeight();
    },
    async fetchAndConvertColumns() {
      await this.fetchColumnsByDisplayColumn();
      this.getDataColumn();
      this.convertDataColumns();
    },
    close() {
      this.$emit("close-dialog");
    },
    submitFormWithValidation() {
      this.$refs.obs.validate().then((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          this.$message.error("Vui lòng nhập đầy đủ trường thông tin.");
        }
      });
    },

    async submitForm() {
      const columnRequests = [];

      this.columns.forEach((col) => {
        if (
          col.name !== "displayName" &&
          col.name !== "phone" &&
          col.name !== "email" &&
          col.name !== "employees" &&
          col.name !== "storage"
        ) {
          let columnRequest = {};

          if (col.columnType === "Date") {
            columnRequest = {
              id: col.id,
              name: col.name,
              value: this.formData[col.name]
                ? new Date(this.formData[col.name]).getTime()
                : null,
            };
          } else if (col.columnType === "Text") {
            columnRequest = {
              id: col.id,
              name: col.name,
              value: this.formData[col.name] ? this.formData[col.name].trim() : null,
            };
          } else if (col.columnType === "Number") {
            const rawValue = this?.formData[col.name];
            if (rawValue) {
              const numericValue = parseFloat(rawValue.replace(/,/g, ""));
              columnRequest = {
                id: col.id,
                name: col.name,
                value: numericValue,
              };
            } else {
              columnRequest = {
                id: col.id,
                name: col.name,
                value: null,
              };
            }
          } else if (col.columnType === "SingleSelect") {
            columnRequest = {
              id: col.id,
              name: col.name,
              value: this.formData[col.name] ? this.formData[col.name] : null,
            };
          } else {
            let value = null;

            if (["MultiSelect", "Array", "ArrayNumber"].includes(col.columnType)) {
              const raw = this.formData[col.name];

              if (Array.isArray(raw) && raw.length > 0) {
                if (col.columnType === "ArrayNumber") {
                  value = JSON.stringify(
                    raw
                      .map(v => Number(v))
                      .filter(v => !isNaN(v))
                  );
                } else {
                  value = JSON.stringify(raw);
                }
              } else {
                value = null;
              }
            } else {
              value = this.contact[col.name];
            }

            columnRequest = {
              id: col.id,
              name: col.name,
              value,
            };
          }
          columnRequests.push(columnRequest);
        }
      });
      const matched = this.contact.processAndWorkflow.find(
        (item) => item.processId === this.processId
      );
      const requestData = {
        workflow: this.newWorkflow.id,
        workflowSource: matched.workflowId,
        processId: matched.processId,
        contactId: this.contact.id,
        displayName:
          (this.formData["displayName"] || this.contact["displayName"]).trim(),
        email:
          this.formData["email"] !== undefined
            ? this.formData["email"] || null
            : this.contact["email"],
        phone: this.formData["phone"] || this.contact["phone"],
        employees: this.formData["employees"]
          ? this.formData["employees"]
          : this.contact.swEmployees.map((e) => e.id),
        storage: this.formData["storageId"] || this.contact["storageId"],
        columns: columnRequests,
      };
      try {
        const response = await HTTP.post("/api/contact/update-for-workflow", requestData);
        if (response.status === "success") {
          this.$message.success("Chuyển bước thành công!");
          this.$emit("updatedContact", this.newWorkflow.id, matched.workflowId);
          this.$emit("updatedWorkflow",this.newWorkflow.id);
          this.$emit("process")
        } else if (response.status === "error") {
          this.$message.error(response.error.message);
        } else {
          alert("Đã xảy ra lỗi trong quá trình cập nhật liên hệ.");
        }
      } catch (error) {
        alert("Không thể cập nhật liên hệ. Vui lòng thử lại sau.");
      }
    },
    getDataColumn() {
      // const length = Math.ceil(this.columns.length / 2);
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columnFirst.length < 6) {
          this.columnFirst.push(this.columns[i]);
        } else {
          // if (i < length) {
          // this.columnFirst.push(this.columns[i]);
          // }
          // else {
          this.columnSecond.push(this.columns[i]);
        }
        // }
        // console.log("🚀 ~ getDataColumn ~  this.columnFirst:",  this.columnFirst)
      }
    },
  },
  computed: {
    getFieldsName() {
      const fields = [];
      this.newWorkflow.columnList.forEach((field) => {
        switch (field) {
          case "displayName": {
            fields.push({
              title: "Họ và tên",
              value: this.contact.displayName,
            });
            break;
          }
          case "phone": {
            fields.push({
              title: "Số điện thoại",
              value: this.contact.phone,
            });
            break;
          }
          case "email": {
            fields.push({
              title: "Email",
              value: this.contact.email,
            });
            break;
          }
          case "storage": {
            fields.push({
              title: "Kho dữ liệu",
              value: this.contact.storageId,
            });
            break;
          }
          case "employees": {
            fields.push({
              title: "Nhân viên",
              value: this.contact.swEmployees.map((e) => e.id),
            });
          }
        }
      });
      if (this.newWorkflow && this.newWorkflow.columnList) {
        this.newWorkflow.columnList.forEach((field) => {
          const lceField = this.contact.LCE?.length
            ? this.contact.LCE.find((lce) => lce.name === field)
            : null;
          if (lceField) {
            switch (lceField.columnType) {
              case "Date": {
                fields.push({
                  title: lceField.title,
                  value: lceField.value ? new Date(Number(lceField.value)) : "",
                });
                break;
              }
              case "MultiSelect": {
                fields.push({
                  title: lceField.title,
                  value: this.parseJsonSafe(lceField.value, []),
                });
                break;
              }
              case "Array":
              case "ArrayNumber": {
                fields.push({
                  title: lceField.title,
                  value: this.parseJsonSafe(lceField.value, []),
                });
                break;
              }
              default: {
                fields.push({
                  title: lceField.title,
                  value: lceField.value,
                });
              }
            }
          }
        });
      }
      return fields;
    },
  },

  mounted() {
    window.addEventListener("resize", this.checkContentHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkContentHeight);
  },
};
</script>

<style scoped></style>
